module.exports = __webpack_public_path__ + "static/media/window.131c674e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/window.svg
// module id = 71
// module chunks = 0